import React, { useState } from 'react';
import './Tabs.css';

export interface TabItem {
    id: string;
    label: string | React.ReactNode;
    content: React.ReactNode;
}

export interface TabsProps {
    items: TabItem[];
    defaultTab?: string;
    onChange?: (tabId: string) => void;
    className?: string;
}

export const Tabs: React.FC<TabsProps> = ({ items, defaultTab, onChange, className = '' }) => {
    const [activeTab, setActiveTab] = useState<string>(defaultTab || items[0]?.id || '');

    if (!items || items.length === 0) return null;

    const handleTabClick = (id: string) => {
        setActiveTab(id);
        if (onChange) onChange(id);
    };

    return (
        <div className={`tabs-container ${className}`}>
            <div className="tabs-header">
                {items.map((tab) => (
                    <button
                        key={tab.id}
                        type="button"
                        className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => handleTabClick(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className="tab-content">
                {items.find((tab) => tab.id === activeTab)?.content}
            </div>
        </div>
    );
};
